import { Card, Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Page from "../../../common/components/Page";
import { RootState } from "../../../store";
import CivilDefendantDetail from "./civil-defendant-detail";
import CivilPlantiffDetail from "./civil-plantiff-detail";
import JudgeDetail from "./judge-detail";
import getConfigs from "../../../GetConfigs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CivilSummary = ({ ...props }) => {
  const [form] = Form.useForm();
  const { civilMaster } = useSelector((state: RootState) => state.global);

  useEffect(() => {
    form.setFieldsValue({ ...civilMaster?.summary?.MAIN[0] });
  }, [civilMaster]);

  const [messageVisible, setMessageVisible] = useState<boolean>(true)
  const configurations = getConfigs([
    "ctCVLSummaryTxt",
  ]);

  return (
    <Page>
      <Page.Content>
        <Row gutter={[16, 16]}>
          {configurations.ctCVLSummaryTxt && messageVisible && (
            <Col xl={23} lg={23} md={23} sm={23} xs={23}>
              <Card>
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
                  <FontAwesomeIcon icon={"times"} onClick={() => setMessageVisible(false)} />
                </div>
                <br />
                <div dangerouslySetInnerHTML={{ __html: configurations.ctCVLSummaryTxt }} />
              </Card>
            </Col>
          )}
          <Col xl={12} lg={12} md={12} sm={23} xs={23}>
            <CivilPlantiffDetail form={form} civilMaster={civilMaster} setActiveKey={props.setActiveKey} />
          </Col>
          <Col xl={11} lg={11} md={11} sm={23} xs={23}>
            <CivilDefendantDetail form={form} civilMaster={civilMaster} setActiveKey={props.setActiveKey} />
          </Col>
          <Col xl={23} lg={23} md={23} sm={23} xs={23}>
            <JudgeDetail form={form} />
          </Col>
        </Row>
      </Page.Content>
    </Page>
  );
};

export default CivilSummary;
